var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#4986FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.668 11.4336H8.66797",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33203 11.4326V8.35258C5.33203 6.99258 6.43203 5.89258 7.79203 5.89258H11.5387C12.8987 5.89258 13.9987 6.73924 13.9987 8.09924",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.652 12.1329C15.3187 12.4529 15.1587 12.9463 15.292 13.4529C15.4587 14.0729 16.072 14.4663 16.712 14.4663H17.332V15.4329C17.332 16.9063 16.1387 18.0996 14.6654 18.0996H7.9987C6.52536 18.0996 5.33203 16.9063 5.33203 15.4329V10.7663C5.33203 9.29294 6.52536 8.09961 7.9987 8.09961H14.6654C16.132 8.09961 17.332 9.29961 17.332 10.7663V11.7329H16.612C16.2387 11.7329 15.8987 11.8796 15.652 12.1329Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6655 12.4124V13.7858C18.6655 14.1591 18.3588 14.4658 17.9788 14.4658H16.6922C15.9722 14.4658 15.3122 13.9391 15.2522 13.2191C15.2122 12.7991 15.3722 12.4058 15.6522 12.1324C15.8988 11.8791 16.2388 11.7324 16.6122 11.7324H17.9788C18.3588 11.7324 18.6655 12.0391 18.6655 12.4124Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.7a28b9fede3ed6d5b91091addb5ee6c4.svg";
export { ForwardRef as ReactComponent };